// ** Gatsby
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

// ** Custom Components
import Box from "../Box"
import Button from "../Button"
import CardContainer from "../CardContainer"
import Container from "../Container"
import Heading from "../Heading"
import SwiperSlider from "../SwiperSlider"
import Text from "../Text"

// ** Helpers
import { parseLink } from "../../utils/helpers"

const SectionFeatures = ({ section }: any) => {
  const { label, title, subTitle, listItems } = section

  return (
    <Container constrainedToBreakPoint className="lg:w-full pl-0 mb-0 pb-0">
      <Box className="max-w-xs mx-auto text-center scroll-pl-6 md:max-w-2xl lg:max-w-max">
        <Heading
          as="h5"
          className="text-gold-500 text-center w-3/5 mx-auto !block lg:w-full"
        >
          {label}
        </Heading>
        <Heading as="h2" className="text-blue-500 pb-8">
          {title}
        </Heading>
        <Text className="lg:max-w-4xl text-center mx-auto">{subTitle}</Text>
      </Box>
      <Box className="w-screen lg:w-full px-3 lg:px-0">
        <SwiperSlider
          className="rounded-[20px] mt-6 lg:mt-8 lg:[&>.swiper-wrapper]:flex-wrap lg:[&>.swiper-wrapper]:gap-5 lg:[&>.swiper-wrapper]:justify-center lg:[&>.swiper-slide]:h-fit"
          childClassName="rounded-[20px] flex flex-col content-bottom overflow-hidden max-w-[75%] shadow-sm hover:shadow-lg"
          slidesPerView="auto"
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 5,
            },
          }}
          navigation={false}
        >
          {listItems.map((item: any, idx: any) => (
            <Link key={idx} to={parseLink(item.linkPrimary)}>
              <CardContainer
                forceHeight={false}
                header={
                  <GatsbyImage
                    image={item.Image?.asset?.gatsbyImageData}
                    alt={item.Image?.asset?.altText || "features"}
                    className="rounded-t-[20px] h-48 lg:h-36"
                  />
                }
              >
                <DecorationSvg
                  color={
                    idx === 0 ? "#D1A754" : idx === 1 ? "#8181C1" : "#874C7F"
                  }
                />
                <Box className="flex flex-col h-60 lg:h-96 xl:h-80">
                  <Heading as="h4" className="text-blue-500 mb-8">
                    {item.title}
                  </Heading>
                  <Box className="flex overflow-auto scrollbar-hide">
                    <Text variant="body-copy">{item.value}</Text>
                  </Box>
                  <Button className="rounded-[20px] text-blue-500 !text-center w-full px-0 mb-0 mt-auto align-baseline flex flex-col justify-between">
                    <Text variant="sm" className="!text-center">
                      {item.linkPrimary?.title}
                    </Text>
                  </Button>
                </Box>
              </CardContainer>
            </Link>
          ))}
        </SwiperSlider>
      </Box>
    </Container>
  )
}

const DecorationSvg = (props: { color: string | undefined }) => {
  return (
    <svg
      className="absolute top-0 left-0"
      width="103"
      height="30"
      viewBox="0 0 173 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M146.267 -154.759C150.01 -154.759 152.336 -152.635 153.348 -151.421C154.359 -150.207 155.978 -147.476 155.168 -143.835L124.52 2.73096C120.778 20.6344 104.796 33.5815 86.5892 33.5815H-10.312C-14.0545 33.5815 -16.381 31.4574 -17.3925 30.2436C-18.404 29.0298 -20.0223 26.2988 -19.2131 22.6574L11.4351 -123.908C15.1777 -141.812 31.0581 -154.759 49.3662 -154.759H146.267ZM146.267 -171.954H49.3662C22.865 -171.954 0.00524521 -153.343 -5.45683 -127.448L-36.004 19.1172C-39.443 35.5034 -26.9005 50.7769 -10.2108 50.7769H86.6903C113.191 50.7769 136.051 32.1654 141.412 6.27119L172.06 -140.294C175.398 -156.579 162.957 -171.954 146.267 -171.954Z"
        fill={props.color}
      />
    </svg>
  )
}

export default SectionFeatures
